import { render, staticRenderFns } from "./resultsGame.vue?vue&type=template&id=1858610e&"
import script from "./resultsGame.vue?vue&type=script&lang=js&"
export * from "./resultsGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports